/**
 * Pure badge helpers — kept in web so unit tests run without server path.
 * Must stay aligned with src/domain/notifications.ts.
 */
import type { NotificationItem, SeenMap } from './types.js';

export function unseenNotificationCount(
  items: NotificationItem[],
  seen: SeenMap,
): number {
  return items.filter((i) => seen[i.id] !== i.stateToken).length;
}

export function markNotificationsSeen(
  items: NotificationItem[],
  prev: SeenMap = {},
): SeenMap {
  const next: SeenMap = { ...prev };
  for (const i of items) {
    next[i.id] = i.stateToken;
  }
  return next;
}
